@if (isShown()) {
  <otc-inline-actions
    (animationend)="animationComplete()"
    class="inline-action-bar"
    [ngClass]="{mobile:ui >= 2 && !isAddin, oai:isAddin, showing:showing, hiding:hiding, formdefaults: formdefaults}">
    @for (item of items; track item; let i = $index) {
      @if (item.enabled) {
        <otc-inline-action-item
          role="menuitem"
          id="{{item.name}}"
          href=""
          title="{{item.name}}"
          icon="{{item.icon}}"
          attr.aria-label="{{item.name}}"
          (keyup.enter)="itemClick(items.indexOf(item), $event)"
          (keydown.space)="itemClick(items.indexOf(item), $event)"
          (click)="itemClick(items.indexOf(item), $event)">
        </otc-inline-action-item>
      }
    }
    @if (enabledCustomMenuItemCount > 0 && isShown()) {
      <otc-inline-action-item
        id="more_menu"
        title="More"
        href=""
        icon="action:action_more32"
        (click)="showHideMoreMenu($event)">
      </otc-inline-action-item>
    }
    <otc-menu
      #moreMenu
      id="moreMenu"
      buttonid="more_menu"
      role="menu">
      @for (menuItem of customItems; track menuItem; let i = $index; let length = $count) {
        <otc-menuitem
          role="menuitem"
          tabindex="0"
          id="{{menuItem.name}}"
          title="{{menuItem.name}}"
          (keyup.enter)="itemClick(customItems.indexOf(menuItem), $event, true)"
          (keydown.space)="itemClick(customItems.indexOf(menuItem), $event, true)"
          (click)="itemClick(customItems.indexOf(menuItem), $event, true)">
          {{menuItem.name}}
        </otc-menuitem>
      }
    </otc-menu>
  </otc-inline-actions>
}